// extracted by mini-css-extract-plugin
module.exports = {"lanes":"_2C_gxkaWLW4-dE5dhCVLAK"};